import { apiAuth, apiResponseType } from ".";

export const getUsersTenantData = (params: {
  tenant_uuid: string;
  page?: number;
}): apiResponseType =>
  apiAuth.get(`tenants/${params.tenant_uuid}/users?page=${params.page || 1}`);

export const registerUserTenantData = (params: {
  payload: any;
  tenant_uuid: string;
}) =>
  apiAuth.postForm(
    `tenants/${params.tenant_uuid}/users/store`,
    params.payload
  ) as apiResponseType;

export const deleteUserTenantData = (params: {
  tenant_uuid: string;
  user_uuid: string;
}) =>
  apiAuth.delete(
    `tenants/${params.tenant_uuid}/users/${params.user_uuid}/destroy`
  ) as apiResponseType;

export const updateUserTenantData = (params: {
  tenant_uuid: string;
  user_uuid: string;
  payload: any;
}) =>
  apiAuth.postForm(
    `tenants/${params.tenant_uuid}/users/${params.user_uuid}/update`,
    params.payload
  ) as apiResponseType;

export const getShowUserTenant = (params: {
  tenant_uuid: string;
  user_uuid: string;
}) =>
  apiAuth.get(
    `tenants/${params.tenant_uuid}/users/${params.user_uuid}/show`
  ) as apiResponseType;

export const setStatusUserTenant = (params: {
  tenant_uuid: string;
  user_uuid: string;
}) =>
  apiAuth.put(
    `tenants/${params.tenant_uuid}/users/${params.user_uuid}/toggle-status`
  ) as apiResponseType;

export const searchUserTenantData = (params: {
  name: string;
  tenant_uuid: string;
}): apiResponseType =>
  apiAuth.get(`tenants/${params.tenant_uuid}/users?name=${params.name}`);
